import React from 'react';

import type { BaseComponentProps } from '@coursera/cds-common';

import getActionsCss from './styles/getActionsCss';

export type Props = BaseComponentProps<'div'>;

const Actions = React.forwardRef(function Actions(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} css={getActionsCss} {...rest}>
      {children}
    </div>
  );
});

if (__DEV__) {
  Actions.displayName = 'TemporaryDrawer.Actions';
}

export default Actions;
